import { onLCP, onFID, onCLS, onFCP, onTTFB } from 'web-vitals';
import { isInBrowser } from './isInBrowser.js';

const supportList = () => {
    try {
        if (isInBrowser() && PerformanceObserver) {
            return PerformanceObserver.supportedEntryTypes || [];
        }
        else {
            return null;
        }
    }
    catch (error) {
        console.error('bili-mirror: supportList 解析异常:', error);
    }
};
// 兼容ios 13.x版本有PerformanceObserver,单无对应key的情况
const isSupportEntryTypes = name => {
    if (isInBrowser()) {
        return supportList().includes(name);
    }
    return false;
};
/**
 * 是否是safari浏览器
 * @returns
 */
function isSafari() {
    return /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
}
/**
 * 获取首次内容绘制(首帧)
 * @param callback
 */
function getFCP(callback) {
    const entryHandler = list => {
        for (const entry of list.getEntries()) {
            if (entry.name === 'first-contentful-paint') {
                observer.disconnect();
                callback({
                    name: 'FCP',
                    value: entry.startTime,
                    rating: entry.startTime < 1600 ? 'good' : entry.startTime > 1600 && entry.startTime < 3000 ? 'normal' : 'poor'
                });
            }
        }
    };
    if (!isSupportEntryTypes('paint'))
        return;
    const observer = new PerformanceObserver(entryHandler);
    observer.observe({ type: 'paint', buffered: true });
}
/**
 * 首字节时间(白屏时间)
 */
function getTTFB(callback) {
    window.addEventListener('load', function () {
        let { responseStart, navigationStart } = window.performance.timing;
        let value = responseStart - navigationStart;
        callback({
            name: 'TTFB',
            value,
            rating: value < 200 ? 'good' : value > 200 && value < 500 ? 'normal' : 'poor'
        });
    });
}
/**
 * 最大内容绘制
 * @param callback
 */
function getLCP(callback) {
    const entryHandler = list => {
        for (const entry of list.getEntries()) {
            observer.disconnect();
            callback({
                name: 'LCP',
                value: entry.startTime,
                rating: entry.startTime < 1600 ? 'good' : entry.startTime > 1600 && entry.startTime < 3000 ? 'normal' : 'poor'
            });
        }
    };
    if (!isSupportEntryTypes('largest-contentful-paint'))
        return;
    const observer = new PerformanceObserver(entryHandler);
    observer.observe({ type: 'largest-contentful-paint', buffered: true });
}
/**
 * 首次输入延迟
 * @param callback
 */
function getFID(callback) {
    const entryHandler = entryList => {
        for (const entry of entryList.getEntries()) {
            observer.disconnect();
            const value = entry.processingStart - entry.startTime;
            callback({
                name: 'FID',
                value,
                rating: value < 100 ? 'good' : value > 100 && value < 300 ? 'normal' : 'poor'
            });
        }
    };
    if (!isSupportEntryTypes('first-input'))
        return;
    const observer = new PerformanceObserver(entryHandler);
    observer.observe({ type: 'first-input', buffered: true });
}
// 获取页面各个时间节点计算指标-数据瀑布流使用
function getPagePerformanceTime(callback) {
    if (!window.performance.getEntriesByType)
        return;
    window.addEventListener('load', function () {
        const performance = window.performance;
        if (performance) {
            // 异步获取,同步duration值可能无法获取
            setTimeout(() => {
                const pnt = performance.getEntriesByType('navigation')[0];
                const pageWaterfallData = {
                    redirectTime: pnt.redirectEnd - pnt.redirectStart,
                    dnsTime: pnt.domainLookupEnd - pnt.domainLookupStart,
                    tcpTime: pnt.connectEnd - pnt.connectStart,
                    sslTime: location.protocol === 'https:' ? pnt.connectEnd - pnt.secureConnectionStart : 0,
                    ttfbTime: pnt.responseStart - pnt.startTime,
                    requestDoneTime: pnt.responseEnd - pnt.responseStart,
                    domParseTime: pnt.domContentLoadedEventEnd - pnt.responseEnd,
                    resourceDownloadTime: pnt.loadEventEnd - pnt.domContentLoadedEventEnd,
                    pageTime: pnt.duration // 页面加载完成耗时
                };
                callback({
                    name: 'PAGETIME',
                    data: pageWaterfallData,
                    value: 1 // 跳过外面的过滤
                });
            }, 0);
        }
    });
}
/**
 * 性能数据指标
 * @param callback
 */
function getWebVitals(callback) {
    // web-vitals 不兼容safari浏览器
    if (isSafari()) {
        getFID(res => {
            callback(res);
        });
        getFCP(res => {
            callback(res);
        });
        getLCP(res => {
            callback(res);
        });
        getTTFB(res => {
            callback(res);
        });
        getPagePerformanceTime(res => {
            callback(res);
        });
    }
    else {
        onLCP(res => {
            callback(res);
        });
        onFID(res => {
            callback(res);
        });
        onCLS(res => {
            callback(res);
        });
        onFCP(res => {
            callback(res);
        });
        onTTFB(res => {
            callback(res);
        });
        getPagePerformanceTime(res => {
            callback(res);
        });
    }
}

export { getWebVitals };
